import { render, staticRenderFns } from "./_base-Finding.vue?vue&type=template&id=108b664c&scoped=true"
import script from "./_base-Finding.vue?vue&type=script&lang=js"
export * from "./_base-Finding.vue?vue&type=script&lang=js"
import style0 from "./_base-Finding.vue?vue&type=style&index=0&id=108b664c&prod&lang=scss&module=true"
import style1 from "./_base-Finding.vue?vue&type=style&index=1&id=108b664c&prod&lang=scss&scoped=true"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "108b664c",
  null
  
)

export default component.exports